export default {
  meta: {
    title: '开店趋势',
    parentPath: ['/dfrc/storemap'],
  },
};
